/**
 * Formatação de datas e números para a interface, em português do Brasil.
 *
 * Sobre o fuso: o DataJud carimba os movimentos com o sufixo `Z`, que
 * significaria UTC, mas os horários são os do relógio do tribunal. A conferência
 * está no README, em "Sobre o horário dos movimentos". Por isso as datas são
 * exibidas em UTC — não para converter nada, e sim para preservar exatamente o
 * horário que o tribunal registrou.
 */

const DATA_HORA = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC",
});

const DATA = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "UTC",
});

export function dataHora(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : DATA_HORA.format(d);
}

export function data(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : DATA.format(d);
}

export function numero(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return "—";
  return valor.toLocaleString("pt-BR");
}

/** "3 anos e 2 meses", "45 dias" — a partir de uma quantidade de dias. */
export function duracao(dias: number | null | undefined): string {
  if (dias === null || dias === undefined) return "—";
  if (dias < 31) return `${dias} ${dias === 1 ? "dia" : "dias"}`;

  // Os anos saem de 365 dias, e não da média de 365,25: senão um processo com
  // exatamente um ano de tramitação apareceria como "11 meses".
  const anos = Math.floor(dias / 365);
  if (anos === 0) {
    const meses = Math.floor(dias / 30.44);
    return `${meses} ${meses === 1 ? "mês" : "meses"}`;
  }

  const meses = Math.floor((dias - anos * 365) / 30.44);
  const parteAnos = `${anos} ${anos === 1 ? "ano" : "anos"}`;
  return meses === 0 ? parteAnos : `${parteAnos} e ${meses} ${meses === 1 ? "mês" : "meses"}`;
}
